import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Subscription } from "rxjs";
import { DetalleOOTTComponent } from "../../oott/detalle-oott/detalle-oott.component";
import { FacturaDTO } from "../../shared/interfaces/factura.interface";
import { OrdenCompraDTO } from "../../shared/models/orden-compra.model";

//import { DialogService } from "../../shared/services/rest/dialog.service";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { FacturaService } from "../../shared/services/rest/factura.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
@Component({
    selector: "app-detalle-factura",
    templateUrl: "./detalle-factura.component.html",
    styleUrls: ["./detalle-factura.component.scss"],
    animations: fuseAnimations,
})
export class DetalleFacturaComponent implements OnInit, OnDestroy {
    origen:string='factura';
    factura: FacturaDTO;
    oocc: number[];
    idFactura: number;
    configuracionOOCC: {};
    subscripciones: Subscription;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private activateRoute: ActivatedRoute,
        private _facturaSrvc: FacturaService,
        private _dialogSrvc: DialogService,
        private _notificacionSrvc: NotificacionesService,
        private _router: Router,
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.configuracionOOCC = {
            asociarFactura: false,
            mostrarBuscador: false,
            linkOOCC:false
        };
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this.activateRoute.params.subscribe((params) => {
                //console.log(params);
                this.idFactura = params["idFactura"];
                this.subscripciones.add(
                    this._facturaSrvc
                        .fetchDetalleFactura(this.idFactura)
                        .subscribe((resp) => {
                            this.factura = resp;
                            this.oocc = resp.idOrdenesCompra;

                            //console.log('Facturas-->');
                            //console.log(resp);
                            //console.log(this.oocc);
                        })
                );
            })
        );
    }

    cambiarEstadoFactura(factura: FacturaDTO) {
        console.log(factura);
        if (factura.pagada) {
            const dialogRef = this._dialogSrvc.abrirDialogConfirm(
                "Factura impaga",
                "¿Está seguro que quiere cambiar el estado de la factura a impaga"
            );

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this._facturaSrvc
                        .unregisterPago(factura.idFactura)
                        .subscribe((resp) => {
                            this.factura.pagada = false;
                            this._facturaSrvc.facturaChanged$.next(this.factura);

                            this._notificacionSrvc.mostrarNotificacion(
                                "Factura fue marcada como impaga",
                                "success"
                            );
                            
                        });
                }
                else{
                    this._facturaSrvc.facturaChanged$.next(this.factura);
                }
            });
        } else {
            const dialogRef = this._dialogSrvc.abrirDialogConfirm(
                "Factura Pagada",
                "¿Está seguro que quiere cambiar el estado de la factura a pagada"
            );

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this._facturaSrvc
                        .registerPago(factura.idFactura)
                        .subscribe((resp) => {
                            this.factura.pagada = true;
                            this._facturaSrvc.facturaChanged$.next(this.factura);
                            this._notificacionSrvc.mostrarNotificacion(
                                "Factura fue marcada como pagada",
                                "success"
                            );
                            //this._router.navigateByUrl("/facturas/"+this.factura.idFactura);

                        });
                }
                else{
                    this._facturaSrvc.facturaChanged$.next(this.factura);
                }
            });
        }
    }

    verOOTT(idOOTT: number) {
        this._dialogSrvc.abrirDialog(
            DetalleOOTTComponent,
            "clase-dialog",
            "800px",
            idOOTT
        );
    }

    //cambiarEstadoFactura(idFactura: number) {
    //    this.subscripciones.add(
    //        this._facturaSrvc.registerPago(idFactura).subscribe((resp) => {
    //            console.log();
    //        })
    //    );
    //}

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
